import 'jquery';
import 'select2';

import initSearchForm from './algolia/SearchForm';

import { initialColors as colors } from './colors';
import countries from './json/countries.json';
import languages from './json/tindex-languages.json';
import { debounce } from './util';

const API_BASE_URL = `${process.env.MIX_API_BASE_URL}/`;

function importAll(r) {
  let images = {};
  r.keys().map((item) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}
const flags = importAll(
  require.context('../images/flags', false, /\.(png|jpe?g|svg)$/),
);

const Tindex = {
  init() {
    window.google.charts.load('current').then(() => {
      Tindex.drawChart();
    });
    Tindex.selectedCategory = 'product';
    Tindex.selectedCountry = null;
    Tindex.selectedFirstLevel = null;
    Tindex.selectedSecondLevel = null;
    Tindex.firstLevelIndex = null;
    Tindex.secondLevelIndex = null;
    Tindex.tableEndpoint = 'calculate';
    Tindex.$categoryFilter = $('.js-tindex-category');
    Tindex.$countryFilter = $('.js-tindex-country');
    Tindex.$countrySelect = $('select', Tindex.$countryFilter);
    Tindex.$search = $('.js-tindex-search');
    Tindex.$searchLabel = Tindex.$search.siblings('label');
    Tindex.$searchInput = $('input', Tindex.$search);
    Tindex.$refine = $('.js-tindex-refine');
    Tindex.$sort = $('.js-tindex-sort');
    Tindex.$counter = $('.js-tindex-counter');
    Tindex.$table = $('.js-tindex-table');
    Tindex.$tableWrapper = $('.js-tindex-table-wrapper');
    Tindex.$description = $('.js-tindex-description');
    Tindex.$theadType = $('.js-tindex-thead-type');
    Tindex.$theadExp = $('.js-tindex-thead-exp');
    Tindex.$showMore = $('.js-tindex-table-more');
    Tindex.$scrollTop = $('.js-tindex-scroll-top');
    Tindex.fetchInitialData();
  },
  createChartControls(defaultColors) {
    const controlsContainer = document.querySelector('.js-tindex-controls');
    const moreButton = document.querySelector('.js-tindex-more');

    if (!controlsContainer.hasChildNodes()) {
      const assetsPath = controlsContainer.getAttribute('data-path');

      for (let index = 1; index < Tindex.tindexAllCols.length; index++) {
        const countryCode = Tindex.tindexChart
          .getDataTable()
          .getColumnLabel(index);

        const flag = document.createElement('span');
        flag.className = 'flag';
        flag.style.backgroundImage = `url(${assetsPath}/dist${
          flags[`${countryCode.toLowerCase()}.svg`]
        })`;
        flag.style.borderColor = defaultColors[index - 1];

        const label = document.createElement('span');
        label.className = 'label';
        label.innerText = countries.find(
          (c) => c['alpha-2'] === countryCode,
        ).name;

        const button = document.createElement('button');
        button.className = Tindex.tindexVisibleCols.includes(index)
          ? null
          : 'disabled hidden';
        button.onclick = () => {
          if (Tindex.tindexVisibleCols.includes(index)) {
            button.classList.add('disabled');
            Tindex.tindexVisibleCols = Tindex.tindexVisibleCols.filter(
              (i) => i !== index,
            );
            Tindex.tindexVisibleColors = Tindex.tindexVisibleColors.filter(
              (i) => i !== defaultColors[index - 1],
            );
          } else {
            button.classList.remove('disabled');
            Tindex.tindexVisibleCols.push(index);
            const insertAt = Tindex.tindexVisibleCols.indexOf(index);
            Tindex.tindexVisibleColors.splice(
              insertAt - 1,
              0,
              defaultColors[index - 1],
            );
          }
          const dataView = Tindex.tindexChart.getView();
          Tindex.tindexVisibleColsWithRoles = Tindex.addRoleColumnsToChart();
          dataView.setColumns(Tindex.tindexVisibleColsWithRoles);
          Tindex.tindexChart.setView(dataView);
          Tindex.tindexChart.setOption('colors', Tindex.tindexVisibleColors);
          Tindex.tindexChart.draw();
        };
        button.appendChild(flag);
        button.appendChild(label);

        controlsContainer.appendChild(button);
      }

      moreButton.onclick = (e) => {
        e.preventDefault();

        const hiddenButtons = controlsContainer.querySelectorAll('.hidden');
        hiddenButtons.forEach((hiddenButton) => {
          hiddenButton.classList.remove('hidden');
        });
        moreButton.classList.add('hidden');
      };
    }
  },
  addRoleColumnsToChart() {
    const getCertainty = function (dataTable, rowNum) {
      return dataTable.getValue(rowNum, 0) < Tindex.currentYear;
    };
    return Tindex.tindexVisibleCols.reduce((result, value, index) => {
      result.push(value);
      if (index >= 1) {
        result.push({
          calc: getCertainty,
          type: 'boolean',
          role: 'certainty',
        });
      }
      return result;
    }, []);
  },
  drawChart() {
    const container = document.querySelector('.js-tindex-chart');

    if (container) {
      Tindex.currentYear =
        parseInt(container.getAttribute('data-year'), 10) ||
        new Date().getFullYear();
      const queryOptions = {
        sendMethod: 'auto',
      };
      const dataFileUrl = container.getAttribute('data-source');
      const customColors = [
        ...container
          .getAttribute('data-custom-colors')
          .split(',')
          .filter(Boolean),
        colors.dark_5,
        colors.light_1,
        colors.dark_4,
        colors.light_2,
        colors.dark_3,
        colors.light_3,
      ];
      const query = new window.google.visualization.Query(
        dataFileUrl,
        queryOptions,
      );

      query.send((response) => {
        if (response.isError()) {
          console.error(
            `Error in query: ${response.getMessage()} ${response.getDetailedMessage()}`,
          );
          return;
        }

        const textChartStyle = {
          color: colors.dark_5,
          fontName: '"ARSMaquettePro", Helvetica, Arial, sans-serif',
        };
        const dataTable = response.getDataTable();
        const view = new window.google.visualization.DataView(dataTable);

        Tindex.tindexAllCols = view.getViewColumns();

        Tindex.tindexVisibleCols =
          Tindex.tindexVisibleCols || Tindex.tindexAllCols.slice(0, 6); // Default: show only first 5 columns (+ label)
        Tindex.tindexVisibleColors =
          Tindex.tindexVisibleColors || customColors.slice(0, 5);
        Tindex.tindexVisibleColsWithRoles = Tindex.addRoleColumnsToChart();

        const options = {
          backgroundColor: '#fff',
          height: 400,
          chartArea: { top: 8, bottom: 32, left: 40, right: 8 },
          legend: { position: 'none' },
          pointsVisible: true,
          lineWidth: 3,
          tooltip: {
            textStyle: { color: colors.dark_5 },
          },
          hAxis: {
            title: '',
            textStyle: textChartStyle,
            baselineColor: 'transparent',
            gridlines: {
              color: colors.light_6,
            },
            minorGridlines: {
              color: colors.light_6,
            },
            slantedText: false,
          },
          vAxis: {
            title: '',
            textStyle: textChartStyle,
            baselineColor: colors.dark_5,
            gridlines: {
              count: 0,
            },
            format: '#%',
          },
          colors: Tindex.tindexVisibleColors,
          animation: {
            duration: 200,
            easing: 'inAndOut',
          },
        };

        view.setColumns(Tindex.tindexVisibleColsWithRoles);
        Tindex.tindexChart = new window.google.visualization.ChartWrapper({
          chartType: 'LineChart',
          dataTable,
          view,
          options,
        });
        Tindex.tindexChart.draw(container);
        Tindex.createChartControls(customColors);

        window.onresize = debounce(() => {
          Tindex.drawChart();
        }, 100);
      });
    }
  },
  resetTable() {
    if (Tindex.pending) {
      // Reset pending fetch calls
      Tindex.controller.abort();
      Tindex.controller = null;
      Tindex.pending = false;
    }

    // remove existing content
    $('tbody', Tindex.$table).remove();
    Tindex.$counter.text('');
    Tindex.$table.removeClass('tindex-table__table--expanded');
    Tindex.$showMore.prop('hidden', true);
    Tindex.$scrollTop.prop('hidden', true);
    Tindex.setStickyOffset(false);
    // add loading
    Tindex.$table.append(
      '<tbody><tr class="loading"><td colspan="7">Loading data...</td></tr></tbody>',
    );
  },
  drawTable(data) {
    const container = Tindex.$table[0];

    if (container) {
      const factbooksLinks = Tindex.$table.data('factbooks');
      const MAX_RESULTS = parseInt(Tindex.$table.data('max-results'));
      // remove existing content and listeners
      $('tbody', Tindex.$table).remove();
      Tindex.$counter.text('');
      $(window).off('scroll.tindextable');
      // draw new data
      const byLang = Tindex.tableEndpoint === 'calculateByLanguage';
      let totalTindex = 0;
      let target50 = false;
      let target70 = false;
      let target90 = false;
      let results = 0;
      const noDataMessage =
        'The COMTRADE database does not provide data for this combination.';

      if (data.length === 0) {
        Tindex.$table.append(
          `<tbody><tr class="loading"><td colspan="7">${noDataMessage}</td></tr></tbody>`,
        );
        Tindex.$counter.text(`0 ${byLang ? 'languages' : 'countries'} found`);
      }

      const countryLinkTitle = 'Visit this country’s Language Data Factbook';

      Object.keys(data).forEach((key, i) => {
        const itemData = data[key];

        if (
          Tindex.selectedCountry &&
          itemData.tindex_raw < 10000
          // || (byLang && itemData.language_code.toLowerCase() === 'ot')
        ) {
          return;
        }

        results++;

        const itemName = byLang
          ? languages.find((l) => l.id === itemData.language_code.toLowerCase())
              ?.name
          : countries.find((c) => c['alpha-3'] === itemData.country_code)
              ?.name ?? itemData.country_name;
        const itemDetails = data[key].details;

        const tbody = document.createElement('tbody');
        const tr = document.createElement('tr');

        let trendColumn = `<td>${i + 1}</td>`;
        if (
          !Tindex.selectedFirstLevel &&
          !Tindex.selectedCountry &&
          itemData.position
        ) {
          trendColumn = `<td class="trend"><div><span class="icon-${
            itemData.position === 'stable'
              ? 'minus'
              : itemData.position === 'lower'
              ? 'arrow-down'
              : 'arrow-up'
          } ${itemData.position}"></span> ${i + 1}</div></td>`;
        }

        let itemLink = '';
        if (!byLang) {
          const countryLink = factbooksLinks.find(
            (c) =>
              c.country_code.toLowerCase() ===
              itemData.country_code.toLowerCase(),
          )?.url;
          if (countryLink) {
            itemLink = `<a href="${countryLink}" target="_blank" data-toggle="tooltip" noreferrer><span class="icon-external-link"></span><span class="tooltip-text">${countryLinkTitle}</span></a>`;
          }
        }
        const lastColItem =
          Tindex.selectedFirstLevel || Tindex.selectedCountry === 'SER'
            ? new Intl.NumberFormat('en', {
                style: 'currency',
                currency: 'USD',
                notation: 'compact',
              }).format(itemData.tindex_raw)
            : Tindex.selectedCountry
            ? new Intl.NumberFormat('en', {
                style: 'currency',
                currency: 'USD',
                notation: 'compact',
              }).format(itemData.commercial_penetration_rate)
            : new Intl.NumberFormat('en', {
                style: 'currency',
                currency: 'USD',
              }).format(itemData.hfce_internet_population);

        tr.innerHTML = `${trendColumn}<td>${itemName}${
          itemData.asterisks_country ? ` ${itemData.asterisks_country}` : ''
        }${
          itemData.asterisks_language ? ` ${itemData.asterisks_language}` : ''
        } ${itemLink}</td><td>${Tindex.formatTindex(
          itemData.tindex_norm,
        )}%</td><td>${new Intl.NumberFormat('en').format(
          itemData.internet_population,
        )}</td><td>${(itemData.internet_penetration * 100).toFixed(
          1,
        )}%</td><td>${lastColItem}</td><td><span class="icon-chevron-down"></span></td>`;
        tr.onclick = (event) => {
          if (event.target.tagName !== 'A') {
            tr.classList.toggle('expanded');
          }
        };
        tbody.appendChild(tr);

        Object.keys(itemDetails).forEach((detailKey) => {
          const detailData = itemDetails[detailKey];

          if (byLang && detailData.country_code === Tindex.selectedCountry) {
            return;
          }

          const detailName = byLang
            ? countries.find((c) => c['alpha-3'] === detailData.country_code)
                ?.name ?? detailData.country_name
            : languages.find(
                (l) => l.id === detailData.language_code.toLowerCase(),
              )?.name;

          let detailLink = '';
          if (byLang) {
            const countryLink = factbooksLinks.find(
              (c) =>
                c.country_code.toLowerCase() ===
                detailData.country_code.toLowerCase(),
            )?.url;
            if (countryLink) {
              detailLink = `<a href="${countryLink}" target="_blank" data-toggle="tooltip" noreferrer><span class="icon-external-link"></span><span class="tooltip-text">${countryLinkTitle}</span></a>`;
            }
          }
          const lastColDetail =
            Tindex.selectedFirstLevel || Tindex.selectedCountry === 'SER'
              ? new Intl.NumberFormat('en', {
                  style: 'currency',
                  currency: 'USD',
                  notation: 'compact',
                }).format(detailData.tindex_raw)
              : Tindex.selectedCountry
              ? new Intl.NumberFormat('en', {
                  style: 'currency',
                  currency: 'USD',
                  notation: 'compact',
                }).format(detailData.commercial_penetration_rate)
              : new Intl.NumberFormat('en', {
                  style: 'currency',
                  currency: 'USD',
                }).format(detailData.hfce_internet_population);

          const detailTr = document.createElement('tr');
          detailTr.innerHTML = `<td></td><td>${detailName}${
            detailData.asterisks_country
              ? ` ${detailData.asterisks_country}`
              : ''
          }${
            detailData.asterisks_language
              ? ` ${detailData.asterisks_language}`
              : ''
          } ${detailLink}</td><td>${Tindex.formatTindex(
            detailData.tindex_norm,
          )}%</td><td>${new Intl.NumberFormat('en').format(
            detailData.internet_population,
          )}</td><td>${(detailData.internet_penetration * 100).toFixed(
            1,
          )}%</td><td>${lastColDetail}</td><td></td>`;
          tbody.appendChild(detailTr);
        });

        totalTindex += itemData.tindex_norm;
        if (totalTindex > 0.5 && !target50) {
          const target = document.createElement('tr');
          target.className = 'target';
          target.innerHTML = `<td colspan="7">Localizing your website for these ${
            i + 1
          } ${
            byLang ? 'languages' : 'countries'
          } gives you access to 50% of the worldwide online sales potential.</td>`;
          tbody.appendChild(target);
          target50 = true;
        } else if (totalTindex > 0.7 && !target70) {
          const target = document.createElement('tr');
          target.className = 'target';
          target.innerHTML = `<td colspan="7">Localizing your website for these ${
            i + 1
          } ${
            byLang ? 'languages' : 'countries'
          } gives you access to 70% of the worldwide online sales potential.</td>`;
          tbody.appendChild(target);
          target70 = true;
        } else if (totalTindex > 0.9 && !target90) {
          const target = document.createElement('tr');
          target.className = 'target';
          target.innerHTML = `<td colspan="7">Localizing your website for these ${
            i + 1
          } ${
            byLang ? 'languages' : 'countries'
          } gives you access to 90% of the worldwide online sales potential.</td>`;
          tbody.appendChild(target);
          target90 = true;
        }

        container.appendChild(tbody);
      });

      if (data.length !== 0) {
        if (results === 0) {
          Tindex.$table.append(
            `<tbody><tr class="loading"><td colspan="7">${noDataMessage}</td></tr></tbody>`,
          );
        } else {
          Tindex.$counter.text(
            `${results} ${
              byLang
                ? `language${results !== 1 ? 's' : ''}`
                : `countr${results !== 1 ? 'ies' : 'y'}`
            } found`,
          );
        }
        if (results > MAX_RESULTS) {
          Tindex.$showMore.prop('hidden', false);
        }
      }

      setTimeout(() => {
        const $window = $(window);
        const $header = Tindex.$table.find('thead');
        Tindex.prevScroll = $window.scrollTop();

        $window.on('scroll.tindextable', function () {
          const currentScroll = $window.scrollTop();
          const topOfTable = Tindex.$table.offset().top;
          const adjustedScroll =
            currentScroll +
            $('.header').outerHeight() +
            ($('#wpadminbar').outerHeight() || 0);

          if (
            !$header.hasClass('pinned') &&
            Tindex.prevScroll > currentScroll &&
            adjustedScroll > topOfTable
          ) {
            $header.addClass('pinned');
          } else if (
            $header.hasClass('pinned') &&
            (adjustedScroll <= topOfTable || Tindex.prevScroll < currentScroll)
          ) {
            $header.removeClass('pinned');
          }
          Tindex.prevScroll = currentScroll;
        });
      }, 2000);
    }
  },
  formatTindex(rawValue) {
    const percValue = rawValue * 100;
    const formattedValue =
      percValue > 1
        ? percValue.toFixed(1)
        : percValue > 0.1
        ? percValue.toFixed(2)
        : percValue > 0.01
        ? percValue.toFixed(3)
        : percValue > 0.001
        ? percValue.toFixed(4)
        : percValue > 0.0001
        ? percValue.toFixed(5)
        : percValue > 0.00001
        ? percValue.toFixed(6)
        : percValue.toFixed(7);
    return formattedValue.replace(/\.?0+$/, '');
  },
  applyFilters(country, product) {
    Tindex.resetTable();

    if (country || (!country && !product)) {
      /*
      if (country === 'SER' && !product) {
        country = null;
      }
      */
      Tindex.controller = new AbortController();
      Tindex.pending = true;
      fetch(
        `${API_BASE_URL}${Tindex.tableEndpoint}${
          country ? `?country_from=${country}` : ''
        }${product ? `&product_code=${product}` : ''}`,
        {
          signal: Tindex.controller.signal,
        },
      )
        .then((response) => response.json())
        .then((data) => {
          Tindex.pending = false;
          Tindex.drawTable(data);

          if (Tindex.$description.length > 0) {
            Tindex.$description.toggleClass('hidden', !(country && product));
          }
          if (country || product) {
            Tindex.$theadExp.text(Tindex.$theadExp.data('filtered'));
          } else {
            Tindex.$theadExp.text(Tindex.$theadExp.data('original'));
          }
        })
        .catch((error) => {
          Tindex.pending = false;
          console.error(error);
        });
    }
  },
  createSelectTemplate(state) {
    if (!state.id) {
      return state.text;
    }
    const country = countries.find((c) => c['alpha-3'] === state.id);

    return $(
      `<span class="tindex-table__selection"><img src="${
        Tindex.assetsPath
      }/dist${flags[`${country['alpha-2'].toLowerCase()}.svg`]}" alt="${
        country.name
      }" /><span>${country.name}</span></span>`,
    );
  },
  initSelect(data) {
    if (Tindex.$countrySelect.length > 0) {
      Tindex.assetsPath = Tindex.$countrySelect.data('path');
      const options = Object.keys(data).map((key) => {
        const country = countries.find((c) => c['alpha-3'] === key);
        return {
          id: key,
          text: country?.name || data[key].country_name,
        };
      });

      Tindex.$countrySelect.select2({
        data: options,
        allowClear: true,
        theme: 'material',
        dropdownParent: Tindex.$countrySelect.parent(),
        templateResult: Tindex.createSelectTemplate,
        templateSelection: Tindex.createSelectTemplate,
      });
      Tindex.$countrySelect.on('select2:open', function () {
        document
          .querySelector('.select2-container--open .select2-search__field')
          .focus();
      });
      Tindex.$countrySelect.on('select2:select', function (e) {
        Tindex.selectedCountry = e.params.data.id;
        Tindex.$searchInput.prop('disabled', false);
        // Apply updated filters
        Tindex.applyFilters(
          Tindex.selectedCountry,
          Tindex.selectedSecondLevel || Tindex.selectedFirstLevel,
        );
      });
      Tindex.$countrySelect.on('select2:clear', function () {
        Tindex.firstLevelIndex.setUiState({
          products_test_4dig: {
            query: '',
          },
        });
        Tindex.$searchInput.prop('disabled', true);
        Tindex.secondLevelIndex.setUiState({
          products_test_4dig: {
            query: '',
          },
        });
        Tindex.$refine.prop('hidden', true);
        Tindex.selectedCountry = null;
        Tindex.selectedFirstLevel = null;
        Tindex.selectedSecondLevel = null;
        // Apply updated filters
        Tindex.applyFilters(null, null);
      });
    }
  },
  initCategoryFilter() {
    if (Tindex.$categoryFilter.length > 0) {
      Tindex.$currenCategoryFilter = $(
        '.tindex-category__selection',
        Tindex.$categoryFilter,
      );
      Tindex.$categoryFilter.on('click', function () {
        Tindex.$categoryFilter.toggleClass('open');
      });
      $(document).on('click', function (e) {
        if (
          e.target !== Tindex.$categoryFilter[0] &&
          Tindex.$categoryFilter.hasClass('open')
        ) {
          Tindex.$categoryFilter.removeClass('open');
        }
      });
      // Init default category filter
      Tindex.firstLevelIndex.setUiState({
        products_test_4dig: {
          configure: {
            filters: `category:${Tindex.selectedCategory} AND dig:1`,
          },
        },
      });

      $('.js-tindex-option', Tindex.$categoryFilter).each((i, item) => {
        const $category = $(item);
        $category.on('click', function () {
          const newCategory = $category.data('category');
          if (Tindex.selectedCategory !== newCategory) {
            Tindex.selectedCategory = $category.data('category');
            Tindex.$currenCategoryFilter.text($('.name', $category).text());
            $category.siblings().removeClass('selected');
            $category.addClass('selected');
            // Reset country filter
            Tindex.$countryFilter.prop(
              'hidden',
              Tindex.selectedCategory === 'service',
            );
            Tindex.$countrySelect.val(null).trigger('change');
            // Reset first level search
            Tindex.$searchInput.prop(
              'disabled',
              Tindex.selectedCategory === 'product',
            );
            Tindex.firstLevelIndex.setUiState({
              products_test_4dig: {
                query: '',
                configure: {
                  filters: `category:${Tindex.selectedCategory} AND dig:1`,
                },
              },
            });
            Tindex.$searchLabel.text(
              Tindex.$searchLabel.data(Tindex.selectedCategory),
            );
            Tindex.$searchInput.attr(
              'placeholder',
              Tindex.$searchInput.data(Tindex.selectedCategory),
            );
            // Reset second level search
            Tindex.secondLevelIndex.setUiState({
              products_test_4dig: {
                query: '',
              },
            });
            Tindex.$refine.prop('hidden', true);
            // Update/reset stored filters and apply
            Tindex.selectedCountry =
              Tindex.selectedCategory === 'service' ? 'SER' : null;
            Tindex.selectedFirstLevel = null;
            Tindex.selectedSecondLevel = null;
            Tindex.applyFilters(Tindex.selectedCountry);
          }
        });
      });
    }
  },
  initFirstLevelSearch() {
    if (Tindex.$search.length > 0) {
      Tindex.firstLevelIndex = initSearchForm(
        Tindex.$search[0],
        (selectedFirstLevel) => {
          Tindex.selectedFirstLevel = selectedFirstLevel;
          if (Tindex.selectedCategory === 'product') {
            if (selectedFirstLevel !== null) {
              Tindex.secondLevelIndex.setUiState({
                products_test_4dig: {
                  configure: {
                    filters: `category:${Tindex.selectedCategory} AND dig:2 AND value_1dig:${Tindex.selectedFirstLevel}`,
                  },
                },
              });
              Tindex.$refine.prop('hidden', false);
            } else {
              Tindex.secondLevelIndex.setUiState({
                products_test_4dig: {
                  query: '',
                },
              });
              Tindex.$refine.prop('hidden', true);
            }
          }
          // Apply updated filters
          Tindex.applyFilters(
            Tindex.selectedCountry,
            Tindex.selectedFirstLevel,
          );
        },
        () => {
          Tindex.secondLevelIndex.setUiState({
            products_test_4dig: {
              query: '',
            },
          });
          Tindex.$refine.prop('hidden', true);
        },
      );
    }
  },
  initSecondLevelSearch() {
    if (Tindex.$refine.length > 0) {
      const $searchWrapper = $('.tindex-search', Tindex.$refine);

      Tindex.secondLevelIndex = initSearchForm(
        $searchWrapper[0],
        (selectedSecondLevel) => {
          Tindex.selectedSecondLevel = selectedSecondLevel;
          // Apply updated filters
          Tindex.applyFilters(
            Tindex.selectedCountry,
            Tindex.selectedSecondLevel || Tindex.selectedFirstLevel,
          );
        },
      );
    }
  },
  initSorting() {
    Tindex.$sort.on('click', function (event) {
      const $button = $(event.target);
      if ($button.is('button')) {
        event.preventDefault();
        if (!$button.hasClass('active')) {
          $('.active', Tindex.$sort).removeClass('active');
          $button.addClass('active');
          Tindex.tableEndpoint = $button.data('endpoint');
          Tindex.$theadType.text($button.data('sortby'));
          Tindex.applyFilters(
            Tindex.selectedCountry,
            Tindex.selectedSecondLevel || Tindex.selectedFirstLevel,
          );
        }
      }
    });
  },
  initShowMore() {
    Tindex.$showMore.on('click', function (event) {
      event.preventDefault();

      const compactedTableHeight = Tindex.$table.outerHeight();

      Tindex.$showMore.prop('hidden', true);
      Tindex.$scrollTop.prop('hidden', false);

      Tindex.setStickyOffset(compactedTableHeight);
      Tindex.$table.addClass('tindex-table__table--expanded');
    });
  },
  initScrollTop() {
    Tindex.$scrollTop.on('click', function (event) {
      event.preventDefault();

      let $header = $('header.header');
      let $headerBottom = $header.find('.header__bottom');
      let offsetTop = $('#tindex-table').offset().top;
      offsetTop -= $header.outerHeight();
      offsetTop -= $headerBottom.length ? $headerBottom.outerHeight() : 0;

      if (typeof offsetTop === 'number' && !Number.isNaN(offsetTop)) {
        offsetTop -= 40; //fixed offset
        window.scrollTo({ top: offsetTop });
      }
    });
  },
  setStickyOffset(position) {
    Tindex.$tableWrapper.css(
      '--compacted-table-offset',
      typeof position === 'number' && !Number.isNaN(position)
        ? position + 'px'
        : '',
    );
  },
  drawInternetAccess(data) {
    const container = document.querySelector('.js-tindex-internet');

    if (container) {
      const assetsPath = container.getAttribute('data-path');
      const restricted = Object.keys(data).filter(
        (key) => data[key].internet_restrictions === 1,
      );

      restricted.forEach((key) => {
        const countryCode = data[key].country_code;
        const country = countries.find((c) => c['alpha-3'] === countryCode);
        const countryDOM = document.createElement('div');
        countryDOM.className = 'countries-list__item';
        const flag = document.createElement('img');
        flag.setAttribute(
          'src',
          `${assetsPath}/dist${
            flags[`${country['alpha-2'].toLowerCase()}.svg`]
          }`,
        );
        flag.setAttribute('alt', country.name);
        const label = document.createElement('p');
        label.innerText = country.name;

        countryDOM.appendChild(flag);
        countryDOM.appendChild(label);
        container.appendChild(countryDOM);
      });
    }
  },
  drawTopCountries(data) {
    const container = document.querySelector('.js-tindex-topcountries');

    if (container) {
      const topTen = Object.keys(data).slice(0, 10);
      const customColors = [
        ...container
          .getAttribute('data-custom-colors')
          .split(',')
          .filter(Boolean),
        colors.dark_6,
        colors.light_1,
        colors.dark_5,
        colors.light_2,
        colors.dark_4,
        colors.light_3,
        colors.dark_3,
        colors.light_4,
        colors.dark_2,
        colors.light_5,
      ];
      let max = Math.round(data[topTen[0]].tindex_norm * 100) + 10;
      max = max > 100 ? 100 : max;

      topTen.forEach((key, i) => {
        const countryDOM = document.createElement('li');
        const countryData = data[key];
        const countryName =
          countries.find((c) => c['alpha-3'] === countryData.country_code)
            ?.name ?? countryData.country_name;
        const tindexPerc = countryData.tindex_norm * 100;

        const label = document.createElement('span');
        label.className = 'top-ten__label';
        label.innerText = countryName;
        countryDOM.appendChild(label);

        const value = document.createElement('span');
        value.className = 'top-ten__value';
        value.setAttribute('data-value', `${tindexPerc.toFixed(1)}%`);
        const bar = document.createElement('span');
        bar.style.width = `${(tindexPerc / max) * 100}%`;
        bar.style.backgroundColor = customColors[i];
        value.appendChild(bar);
        countryDOM.appendChild(value);
        container.appendChild(countryDOM);
      });
    }
  },
  drawTopLangs(data) {
    const container = document.querySelector('.js-tindex-toplangs');

    if (container) {
      const topTen = Object.keys(data).slice(0, 10);
      const customColors = [
        ...container
          .getAttribute('data-custom-colors')
          .split(',')
          .filter(Boolean),
        colors.dark_6,
        colors.light_1,
        colors.dark_5,
        colors.light_2,
        colors.dark_4,
        colors.light_3,
        colors.dark_3,
        colors.light_4,
        colors.dark_2,
        colors.light_5,
      ];
      let max = Math.round(data[topTen[0]].tindex_norm * 100) + 10;
      max = max > 100 ? 100 : max;

      topTen.forEach((key, i) => {
        const langDOM = document.createElement('li');
        const langData = data[key];
        const langName = languages.find(
          (l) => l.id === langData.language_code.toLowerCase(),
        )?.name;
        const tindexPerc = langData.tindex_norm * 100;

        const label = document.createElement('span');
        label.className = 'top-ten__label';
        label.innerText = langName;
        langDOM.appendChild(label);

        const value = document.createElement('span');
        value.className = 'top-ten__value';
        value.setAttribute('data-value', `${tindexPerc.toFixed(1)}%`);
        const bar = document.createElement('span');
        bar.style.width = `${(tindexPerc / max) * 100}%`;
        bar.style.backgroundColor = customColors[i];
        value.appendChild(bar);
        langDOM.appendChild(value);
        container.appendChild(langDOM);
      });
    }
  },
  fetchInitialData() {
    fetch(`${API_BASE_URL}calculate`)
      .then((response) => response.json())
      .then((data) => {
        Tindex.drawTable(data);
        Tindex.drawInternetAccess(data);
        Tindex.drawTopCountries(data);
        Tindex.initSelect(data);
        Tindex.initFirstLevelSearch();
        Tindex.initSecondLevelSearch();
        Tindex.initCategoryFilter();
        Tindex.initSorting();
        Tindex.initShowMore();
        Tindex.initScrollTop();
      })
      .catch((error) => console.error(error));

    fetch(`${API_BASE_URL}calculateByLanguage`)
      .then((response) => response.json())
      .then((data) => {
        Tindex.drawTopLangs(data);
      })
      .catch((error) => console.error(error));
  },
};

$(document).ready(Tindex.init);
